import {KEYFRAMETARGETS, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {watch} from "vue";

export function setWatchToAnimateOnStatechange(animation:(target)=>void, keyframes:KeyFrameTargetValues, getter:()=>KEYFRAMETARGETS) {
    watch(getter, newState=>animation(keyframes.getTarget(newState)));
}
